import React from "react";

import { GridColumnMenu } from "@mui/x-data-grid";

import { IconButton, MenuItem } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";

export default function CustomColumnMenu(props) {
  const {
    openOptionEditor,
    setCarrierDialog,
    setCreditDialog,
    isAdmin,
    setClaimDialog,
    isSuperAdmin,
    openPermissionDialog,
  } = props;

  return (
    <GridColumnMenu
      {...props}
      slots={{
        columnMenuUserItem: () => {
          return (
            <>
              {/* SELECT OPTION EDITOR */}
              {isAdmin && props.colDef.type === "singleSelect" && (
                <MenuItem
                  onClick={() => {
                    openOptionEditor(props.colDef.field);
                    props.hideMenu?.();
                  }}
                >
                  ⚙ Edit Options
                </MenuItem>
              )}

              {/* CARRIER MENU */}
              {isAdmin && props.colDef.field === "carrier" && (
                <MenuItem
                  onClick={() => {
                    setCarrierDialog(true);
                    props.hideMenu?.();
                  }}
                >
                  ➕ Add Carrier
                </MenuItem>
              )}

              {isAdmin && props.colDef.field === "reason_for_claim" && (
                <MenuItem
                  onClick={() => {
                    setClaimDialog(true);
                    props.hideMenu?.();
                  }}
                >
                  ➕ Add Claim
                </MenuItem>
              )}

              {isAdmin && props.colDef.field === "credit_type" && (
                <MenuItem
                  onClick={() => {
                    setCreditDialog(true);
                    props.hideMenu?.();
                  }}
                >
                  ➕ Add Credit
                </MenuItem>
              )}
              {isAdmin && props.colDef.field === "list" && (
                <MenuItem
                  onClick={() => {
                    setCreditDialog(true);
                    props.hideMenu?.();
                  }}
                >
                  ➕ Add Credit
                </MenuItem>
              )}
              {isSuperAdmin && (
                <MenuItem
                  onClick={() => {
                    openPermissionDialog(props.colDef.field);
                    props.hideMenu?.();
                  }}
                >
                  <LockIcon fontSize="small" sx={{ mr: 1 }} />
                  Column Permissions
                </MenuItem>
              )}
            </>
          );
        },
      }}
      slotProps={{
        columnMenuUserItem: {
          displayOrder: 15,
        },
      }}
    />
  );
}
